//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TopicItem",
  created() {},
  props: ["topic"],
  data() {
    return {};
  },
  methods: {
    goToTopic: function() {
      this.$router.push({ name: "topic", params: { id: this.topic.id } });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/topic/TopicItem.vue